import React from 'react';
import PropTypes from 'prop-types';
import { StyledCardContent } from './StyledCardContent';
function CardContent(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(StyledCardContent, null, children);
}
CardContent.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The content of the component. React component, node, text etc.
   */
  children: PropTypes.node.isRequired
} : {};
CardContent.defaultProps = {};
export default CardContent;